import React, { useState, useEffect } from "react";
import styled from 'styled-components';

const OverallContainer = styled.div`
text-align: center;
align-self: center;
background-color: #4A4A4A;
color: white;
font-family: Poppins;
font-style: normal;
font-weight: 800;
font-size: 24px;
line-height: 36px;
padding-top: 20px;
padding-bottom: 20px;
`
const HeadingsContainer = styled.div`
display: flex;
flex-direction: row;
text-align: center;
align-content: center;
justify-content: center;
`

const HeadingsTextYellow = styled.a`
font-family: 'Courier New', Courier, monospace;
align-self: center;
align-content: center;
padding-right: 15px;
color: #F8F27F;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 15px;
line-height: 21px;
text-decoration: none;
text-transform: uppercase;
/* min-width: 30%; */
`

const HeadingsTextBlue = styled.a`
font-family: 'Courier New', Courier, monospace;
align-self: center;
align-content: center;
padding-right: 15px;
color: #72D0F0;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 15px;
line-height: 21px;
text-decoration: none;
text-transform: uppercase;
/* min-width: 30%; */
`


function Nav() {
    return (
        <OverallContainer>
            HISPANIC HERITAGE MONTH
            <HeadingsContainer>
                <HeadingsTextYellow href="#1">Arts and culture</HeadingsTextYellow>
                <HeadingsTextBlue href="#2">Community in action</HeadingsTextBlue>
            </HeadingsContainer>
        </OverallContainer>
    );
}

export default Nav;